import type { ReactNode } from 'react';

import styles from './IconDisc.module.css';

/**
 * An icon in an accent disc — the welcome card's avatar treatment, for the
 * icon that heads a card (a metric tile, the two-step verification panel, a
 * report section). Decorative: the heading beside it carries the meaning,
 * so the disc is hidden from assistive technology.
 */
export interface IconDiscProps {
  children: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function IconDisc({ children, size = 'md', className }: IconDiscProps) {
  return (
    <span
      className={[styles['disc'], styles[size], className].filter(Boolean).join(' ')}
      aria-hidden="true"
    >
      {children}
    </span>
  );
}
